module.exports = __webpack_public_path__ + "static/media/wrench.7c980e84.svg";